import {type UINotificationActionController} from './notifications/UINotificationActionController.ts'
import {type UIOnlineFriendController} from './ui_friends/UIOnlineFriendController.ts'

export class UIGeneralServicesController {
    onlineFriendController: UIOnlineFriendController | undefined
    notificationActionController: UINotificationActionController | undefined
}
